export default class GrantsConstraintsPlansFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.textSearch = "";
  }
  fillData(data) {
    this.textSearch = data.textSearch;
  }
}
